import script from "./EtagePlanComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EtagePlanComponent.vue?vue&type=script&setup=true&lang=js"

import "./EtagePlanComponent.vue?vue&type=style&index=0&id=b8b657d6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8b657d6"]])

export default __exports__